import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Disposable } from './lifecycle.js';
import { Emitter } from './event.js';
export var Action = /*#__PURE__*/function (_Disposable) {
  _inherits(Action, _Disposable);

  var _super = _createSuper(Action);

  function Action(id) {
    var _this;

    var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var cssClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var enabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var actionCallback = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, Action);

    _this = _super.call(this);
    _this._onDidChange = _this._register(new Emitter());
    _this.onDidChange = _this._onDidChange.event;
    _this._enabled = true;
    _this._checked = false;
    _this._id = id;
    _this._label = label;
    _this._cssClass = cssClass;
    _this._enabled = enabled;
    _this._actionCallback = actionCallback;
    return _this;
  }

  _createClass(Action, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "label",
    get: function get() {
      return this._label;
    },
    set: function set(value) {
      this._setLabel(value);
    }
  }, {
    key: "_setLabel",
    value: function _setLabel(value) {
      if (this._label !== value) {
        this._label = value;

        this._onDidChange.fire({
          label: value
        });
      }
    }
  }, {
    key: "tooltip",
    get: function get() {
      return this._tooltip || '';
    },
    set: function set(value) {
      this._setTooltip(value);
    }
  }, {
    key: "_setTooltip",
    value: function _setTooltip(value) {
      if (this._tooltip !== value) {
        this._tooltip = value;

        this._onDidChange.fire({
          tooltip: value
        });
      }
    }
  }, {
    key: "class",
    get: function get() {
      return this._cssClass;
    },
    set: function set(value) {
      this._setClass(value);
    }
  }, {
    key: "_setClass",
    value: function _setClass(value) {
      if (this._cssClass !== value) {
        this._cssClass = value;

        this._onDidChange.fire({
          class: value
        });
      }
    }
  }, {
    key: "enabled",
    get: function get() {
      return this._enabled;
    },
    set: function set(value) {
      this._setEnabled(value);
    }
  }, {
    key: "_setEnabled",
    value: function _setEnabled(value) {
      if (this._enabled !== value) {
        this._enabled = value;

        this._onDidChange.fire({
          enabled: value
        });
      }
    }
  }, {
    key: "checked",
    get: function get() {
      return this._checked;
    },
    set: function set(value) {
      this._setChecked(value);
    }
  }, {
    key: "_setChecked",
    value: function _setChecked(value) {
      if (this._checked !== value) {
        this._checked = value;

        this._onDidChange.fire({
          checked: value
        });
      }
    }
  }, {
    key: "run",
    value: function run(event, _data) {
      if (this._actionCallback) {
        return this._actionCallback(event);
      }

      return Promise.resolve(true);
    }
  }]);

  return Action;
}(Disposable);
export var ActionRunner = /*#__PURE__*/function (_Disposable2) {
  _inherits(ActionRunner, _Disposable2);

  var _super2 = _createSuper(ActionRunner);

  function ActionRunner() {
    var _this2;

    _classCallCheck(this, ActionRunner);

    _this2 = _super2.apply(this, arguments);
    _this2._onDidBeforeRun = _this2._register(new Emitter());
    _this2.onDidBeforeRun = _this2._onDidBeforeRun.event;
    _this2._onDidRun = _this2._register(new Emitter());
    _this2.onDidRun = _this2._onDidRun.event;
    return _this2;
  }

  _createClass(ActionRunner, [{
    key: "run",
    value: function run(action, context) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (action.enabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(null));

              case 2:
                this._onDidBeforeRun.fire({
                  action: action
                });

                _context.prev = 3;
                _context.next = 6;
                return this.runAction(action, context);

              case 6:
                result = _context.sent;

                this._onDidRun.fire({
                  action: action,
                  result: result
                });

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

                this._onDidRun.fire({
                  action: action,
                  error: _context.t0
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10]]);
      }));
    }
  }, {
    key: "runAction",
    value: function runAction(action, context) {
      var res = context ? action.run(context) : action.run();
      return Promise.resolve(res);
    }
  }]);

  return ActionRunner;
}(Disposable);
export var Separator = /*#__PURE__*/function (_Action) {
  _inherits(Separator, _Action);

  var _super3 = _createSuper(Separator);

  function Separator(label) {
    var _this3;

    _classCallCheck(this, Separator);

    _this3 = _super3.call(this, Separator.ID, label, label ? 'separator text' : 'separator');
    _this3.checked = false;
    _this3.enabled = false;
    return _this3;
  }

  return Separator;
}(Action);
Separator.ID = 'vs.actions.separator';
export var SubmenuAction = /*#__PURE__*/function (_Action2) {
  _inherits(SubmenuAction, _Action2);

  var _super4 = _createSuper(SubmenuAction);

  function SubmenuAction(id, label, _actions, cssClass) {
    var _this4;

    _classCallCheck(this, SubmenuAction);

    _this4 = _super4.call(this, id, label, cssClass, true);
    _this4._actions = _actions;
    return _this4;
  }

  _createClass(SubmenuAction, [{
    key: "actions",
    get: function get() {
      return Array.isArray(this._actions) ? this._actions : this._actions();
    }
  }]);

  return SubmenuAction;
}(Action);